import * as React from "react";
import * as ReactDOM from "react-dom/client";

import { getDeliveryAddressInfo } from "../components/DeliveryLocation/user-settings";

import { ZipDisplayComponent } from "../components/DeliveryLocation/Display/location-zip-display";

/*

This wires up the zip selection element in the header.  
Shown after the user has selected a zip code.  
Allows for editing of the zip code selection.
 
*/

export const setupZipDisplay = () => {
  const address = getDeliveryAddressInfo();

  const searchRoot = document.getElementById("zipcode-selection");

  if (searchRoot) {
    const root = ReactDOM.createRoot(searchRoot);

    root.render(
      <>
        <ZipDisplayComponent address={address} />
      </>
    );
  }
};
